import { StateLink } from "@/storeLocator/components/StatesList/types";

const createStatesListChunks = (list: StateLink[]): StateLink[][] => {
    if (!list) return [];

    const chunkedStates = [];
    for (let i = 0; i < list.length; i += 13) {
        chunkedStates.push(list.slice(i, i + 13));
    };

    return chunkedStates;
};

export default createStatesListChunks;